export const REPORTING_HEATMAP_PAGE = 'reporting-heatmap-page';
export const OUTLOOK_INTEGRATION = 'admin-outlook-integration';
export const OUTLOOK_AUDIT_LOGS = 'outlook-audit-logs';
export const AM_GROUP_MANAGEMENT = 'am-group-management';
export const OBJECT_EXPORT = 'object-manager-export';
export const OBJECT_IMPORT = 'object-manager-import';
export const EXAM_LAYOUT_PATTERN = 'exam-layout-pattern';
export const AUTH_CONFIG_AFFILIATION_TYPE =
  'admin-auth-config-affiliation-type';
export const USE_AOP_TOPBAR = 'te-admin-fe-use-aop-topbar';
export const HUB_CONFIGURATION = 'admin-hub-configuration';
